module.exports = "<ace-editor [(text)]=\"text\" #editor class=\"codeviewer-container\"></ace-editor>\n"